import React, { useState, useCallback, useEffect } from 'react'
import { Formik, Form, Field } from 'formik'
import { useModal } from 'react-modal-hook'
import Loading from 'custom/assets/loaders/Loading'
import { NeoOTP, NeoSuccess } from '../../components/FormComponents'
import Modal from '../../components/Modal/Modal'
import NeoButton from '../../components/NeoButton/NeoButton'
import LayoutWithOutAccountCard from '../Layout/layout-without-card'
import { useHistory } from 'react-router-dom'
import NeoInput from '../../components/NeoInput/NeoInput'
import InputError from '../../components/InputError/InputError'
import { getAccountListSelector } from '../../store/selectors/app.selector'
import { useDispatch, useSelector } from 'react-redux'
import BeneficiaryService from '../../services/beneficiary.service'
import TransferService from '../../services/transfer.service'
import { setIsAcctRefresh } from '../../store/actions/app.actions'
import { BulkTransferSchema } from '../../schemas/transfers'
import { BUTTON_KEYS, BULK_TRANSFER_KEYS } from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next'
import validationConfig from 'custom/config/validation.config.json'
const bulkTransferConfig = validationConfig['bulkTransfer']
const transferType = []

export default function BulkTransfer() {
  const history = useHistory()
  const dispatch = useDispatch()
  const [stage, setStage] = useState(0)
  const [message, setMessage] = useState('')
  const [loading, setLoading] = useState(false)
  const [otp, setOtp] = useState('')
  const accountList = useSelector(getAccountListSelector) || []
  const [beneList, setBeneList] = useState([])
  const [transferList, setTransferList] = useState([])
  const [noRecords, setNoRecords] = useState(false)
  const [verifyDetails, setVerifyDetails] = useState({})
  const [otpEnabled, setOtpEnabled] = useState(false)
  const [responseList, setResponseList] = useState([])
  const [transferTypeList, setTransferTypeList] = useState([])
  const [currencyList, setCurrencyList] = useState([])
  const [selectedAccountCcy, setSelectedAccountCcy] = useState([])
  const { t } = useTranslation()

  useEffect(() => {
    fetchBeneficiaries()
  }, [])

  const fetchBeneficiaries = useCallback(async () => {
    try {
      const response = await BeneficiaryService.getBeneList()
      if (response.status === 200) {
        const beneDetails = [
          ...response.data['internalBeneList'],
          ...response.data['otherBankBeneList'],
        ]
        setNoRecords(beneDetails.length > 0 ? false : true)
        setBeneList(beneDetails)
        setStage(1)
      }
    } catch (err) {
      //   setMessage(err.data)
      //   //showModal()
    }
  }, [])

  const onAdd = useCallback(
    (values, { resetForm, setFieldValue }) => {
      try {
        const accDetails = accountList.filter((ele) => ele.accountNo === values.accountNo)[0]
        const beneDetails = beneList.filter((b) => b.beneAccNo === values.beneAccNo)[0]
        const transferListCopy = [...transferList]
        const txnCurrencyCopy = [...currencyList]
        transferListCopy.push({
          rowId: transferList.length + 1,
          fin: {
            srcAccount: accDetails.accountNo,
            srcAccBranch: accDetails.brnCode,
            srcAccCcy: accDetails.currency,
            destAccount: beneDetails.beneAccNo,
            destAccBranch: beneDetails.beneBrn,
            destAccCcy: beneDetails.beneCurrency || '',
            destBankName: beneDetails.bankName || '',
            destBankCountry: '',
            destBankAddress: '',
            beneAddress: '',
            modeOfTransfer: '',
            amount: values.maxTransferAmount,
            txnCurrency: values.txnCurrency,
            bicCode: beneDetails.bicCode || '',
            sortCode: beneDetails.sortCode || '',
            remarks: values.remarks,
            chargesBorneBy: '',
            txnDate: '',
          },
          nfin: {
            transferType: values.transferType,
            beneId: beneDetails.reqId,
            scheduled: false,
            scheduledDate: '',
            beneficiaryName: beneDetails.beneName,
            beneficiaryMail: beneDetails.beneEMail || '',
            beneficiaryMobile: beneDetails.beneMobileNo || '',
            addBeneficiary: false,
            bulkTransfer: true,
          },
          cdf: {},
        })
        setTransferList(transferListCopy)
        setCurrencyList(txnCurrencyCopy)
        resetForm()
        setFieldValue('amount', '')
      } catch (err) {}
    },
    [transferList, accountList, beneList],
  )
  const handleDelete = useCallback(
    (selected) => {
      try {
        let transferListCopy = [...transferList]
        transferListCopy = transferListCopy.filter((ele) => ele.rowId !== selected.rowId)
        transferListCopy.forEach((ele, index) => ele.rowId == index + 1)
        setTransferList(transferListCopy)
      } catch (err) {}
    },
    [transferList],
  )

  const onVerify = useCallback(async () => {
    try {
      setLoading(true)
      const reqParams = {
        ftList: [...transferList],
      }
      const response = await TransferService.verifyBulkTransfer(reqParams)
      if (response.status === 200) {
        setLoading(false)
        setOtpEnabled(response.data['otpEnable'])
        setVerifyDetails(response.data)
        if (response.data['otpEnable']) {
          setStage(2)
          return
        }
        const response1 = await TransferService.confirmBulkTransfer({
          ftList: [...transferList],
          otp: '0000',
          randomKey: response.data['randomKey'],
        })
        if (response1.status === 200) {
          setResponseList(response1.data['responseList'])
          dispatch(setIsAcctRefresh(true))
          setStage(3)
          setLoading(false)
        }
      }
    } catch (err) {
      setLoading(false)
      console.log(err?.data)
      setMessage(err?.data)
      //showModal()
    }
  }, [transferList])

  const onConfirm = useCallback(async () => {
    try {
      setLoading(true)
      const reqParams = {
        ftList: [...transferList],
        otp: otp || '0000',
        randomKey: verifyDetails.randomKey,
      }
      const response = await TransferService.confirmBulkTransfer(reqParams)
      if (response.status === 200) {
        setResponseList(response.data['responseList'])
        dispatch(setIsAcctRefresh(true))
        setStage(3)
        setLoading(false)
      }
    } catch (err) {
      setMessage(err?.data)
      setOtp('')
      //showModal()
      setLoading(false)
    }
  }, [transferList, otp, verifyDetails])

  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderLoading()
      case 1:
        return renderForm()
      case 2:
        return (
          <div className='new-design-form-style'>
            <NeoOTP otp={otp} setOTP={setOtp} onSubmit={onConfirm} loading={loading} />
          </div>
        )
      case 3:
        return renderSuccess()
      default:
        return renderForm()
    }
  }

  function renderForm() {
    return (
      <div className='bt-style'>
        {noRecords && <div className='no-data-found'>{t(BULK_TRANSFER_KEYS.NO_RECORDS)}</div>}
        {beneList.length > 0 && (
          <Formik
            initialValues={{
              accountNo: '',
              beneAccNo: '',
              remarks: '',
              maxTransferAmount: '',
              txnCurrency: '',
              transferType: '',
            }}
            enableReinitialize
            validationSchema={BulkTransferSchema}
            onSubmit={onAdd}>
            {({ isSubmitting, errors, touched, handleChange, values, setFieldValue }) => (
              <Form>
                <div className='row'>
                  <div className='form-group col-3'>
                    <label className='control-label'>
                      {t(BULK_TRANSFER_KEYS.ACCOUNT_NO)}{' '}
                      {bulkTransferConfig['isAccountNoRequired'] ? '*' : ''}
                    </label>
                    <Field tabIndex={'1'} as='select' className='form-control' name='accountNo' disabled={loading}
                      onChange={(e) => {
                        const selectedAccount = accountList.filter((ele) => ele.accountNo === e.target.value)[0]
                        setFieldValue('accountNo', e.target.value)
                        setSelectedAccountCcy(selectedAccount.currency)
                      }}
                    >
                      <option disabled value='' />
                      {accountList?.map((item, index) => (
                        <option key={index} value={item.accountNo}>
                          {item.accountNo}
                        </option>
                      ))}
                    </Field>
                    <InputError text={errors.accountNo} touched={touched.accountNo} />
                  </div>

                  <div className='form-group col-3'>
                    <label className='control-label'>
                      {t(BULK_TRANSFER_KEYS.BENEFICIARY_NAME)}{' '}
                      {bulkTransferConfig['isBeneNameRequired'] ? '*' : ''}
                    </label>
                    <Field
                      tabIndex={'2'}
                      onChange={(e) => {
                        const type = beneList.filter((ele) => ele.beneAccNo === e.target.value)[0]
                          !type.beneCurrency? setCurrencyList([selectedAccountCcy])
                          :(
                            type.beneCurrency === selectedAccountCcy ?
                            setCurrencyList([type.beneCurrency]) :
                            setCurrencyList([selectedAccountCcy,type.beneCurrency])
                          )
                        setFieldValue('beneAccNo', e.target.value)
                        setFieldValue('transferType', '')
                        setFieldValue('txnCurrency', selectedAccountCcy)
                        setTransferTypeList(
                          type.beneType === 'INTERNATIONAL'
                            ? ['SWIFT']
                            : type.beneType === 'THIRD_PARTY'
                              ? ['DDACC', 'RTGS']
                              : ['IAT'],
                        )
                      }}
                      as='select'
                      className='form-control'
                      name='beneAccNo'
                      disabled={loading}>
                      <option disabled value='' />
                      {beneList?.map((item, index) => (
                        <option key={index} value={item.beneAccNo}>
                          {item.beneName}
                        </option>
                      ))}
                    </Field>
                    <InputError text={errors.beneAccNo} touched={touched.beneAccNo} />
                  </div>

                  <div className='form-group col-3'>
                    <label className='control-label'>
                      {t(BULK_TRANSFER_KEYS.TRANSFER_TYPE)}{' '}
                      {bulkTransferConfig['isTransferTypeRequired'] ? '*' : ''}
                    </label>
                    <Field
                      tabIndex={'3'}
                      as='select'
                      className='form-control'
                      name='transferType'
                      disabled={loading}>
                      <option disabled value='' />
                      {transferTypeList?.map((item, index) => (
                        <option key={index} value={item}>
                          {item}
                        </option>
                      ))}
                    </Field>
                    <InputError text={errors.transferType} touched={touched.transferType} />
                  </div>

                  <div className='form-group col-3'>
                    {/* <label className='control-label'>Amount *</label>
                    <Field
                      as='input'
                      className='form-control'
                      name='maxTransferAmount'
                      disabled={loading}
                    />  */}
                    <NeoInput
                      tabIndex='4'
                      showAsterisk={bulkTransferConfig['isAmountRequired']}
                      text={t(BULK_TRANSFER_KEYS.TRANSFER_AMOUNT)}
                      type='number'
                      mode='amount'
                      disabled={loading}
                      onChange={(value) => {
                        setFieldValue('maxTransferAmount', value?.value)
                      }}
                      value={values.maxTransferAmount}
                      name='amount'
                    />
                    <InputError
                      text={errors.maxTransferAmount}
                      touched={touched.maxTransferAmount}
                    />
                  </div>

                  <div className='form-group col-3'>
                    <label className='control-label'>
                      {t(BULK_TRANSFER_KEYS.TXN_CURRENCY)}{' '}
                      {bulkTransferConfig['isTxnCurrencyRequired'] ? '*' : ''}
                    </label>
                    <Field
                      tabIndex={'5'}
                      as='select'
                      className='form-control'
                      name='txnCurrency'
                      disabled={loading}>
                      <option disabled value='' />
                      {currencyList?.map((item, index) => (
                        <option key={index} value={item}>
                          {item}
                        </option>
                      ))}
                    </Field>
                    <InputError text={errors.txnCurrency} touched={touched.txnCurrency} />
                  </div>

                  <div className='form-group col-3'>
                    <label className='control-label'>
                      {t(BULK_TRANSFER_KEYS.REMARKS)}{' '}
                      {bulkTransferConfig['isRemarksRequired'] ? '*' : ''}
                    </label>
                    <Field tabIndex={'6'} as='input' className='form-control' name='remarks' disabled={loading} />
                    <InputError text={errors.remarks} touched={touched.remarks} />
                  </div>

                  <div
                    className='col-2'
                    style={{ display: 'flex', alignItems: 'center', marginTop: 25 }}>
                    <NeoButton tabIndex='7' type='submit' text={t(BUTTON_KEYS.ADD)} mode='newDesign' />
                  </div>
                  <div
                    className='col-3'
                    style={{ display: 'flex', alignItems: 'center', marginTop: 25 }}>
                    {loading ? (
                      renderLoading()
                    ) : (
                      <NeoButton
                        tabIndex='8'
                        type='button'
                        text={t(BUTTON_KEYS.SUBMIT)}
                        onClick={() => onVerify()}
                        disabled={transferList.length === 0}
                        mode='newDesign'
                      />
                    )}
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        )}

        <div className='bulk-transfer-data'>
          {transferList.length > 0 && (
            <table style={{ width: '100%' }}>
              <thead>
                <tr>
                  <th>{t(BULK_TRANSFER_KEYS.ACCOUNT_NO)}</th>
                  <th>{t(BULK_TRANSFER_KEYS.BENEFICIARY_NAME)}</th>
                  <th>{t(BULK_TRANSFER_KEYS.TRANSFER_TYPE)}</th>
                  <th>{t(BULK_TRANSFER_KEYS.REMARKS)}</th>
                  <th>{t(BULK_TRANSFER_KEYS.AMOUNT)}</th>
                  <th>{t(BULK_TRANSFER_KEYS.TXN_CURRENCY)}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {transferList.map((option, index) => (
                  <tr key={index}>
                    <td>{option.fin.srcAccount}</td>
                    <td>{option.nfin.beneficiaryName}</td>
                    <td>{option.nfin.transferType}</td>
                    <td>{option.fin.remarks}</td>
                    <td>{option.fin.amount}</td>
                    <td>{option.fin.txnCurrency}</td>
                    <td>
                      <i
                        className='icon material-icons'
                        onClick={() => handleDelete(option)}
                        style={{ cursor: 'pointer' }}>
                        delete
                      </i>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    )
  }

  function renderSuccess() {
    return (
      <>
        <div className='bulk-transfer-data bt-style '>
          {responseList.length > 0 && (
            <table style={{ width: '110%' }}>
              <thead>
                <tr>
                  <th>{t(BULK_TRANSFER_KEYS.REF_NO)}</th>
                  <th>{t(BULK_TRANSFER_KEYS.ACCOUNT_NO)}</th>
                  <th>{t(BULK_TRANSFER_KEYS.BENEFICIARY_NAME)}</th>
                  <th>{t(BULK_TRANSFER_KEYS.TRANSFER_TYPE)}</th>
                  <th>{t(BULK_TRANSFER_KEYS.REMARKS)}</th>
                  <th>{t(BULK_TRANSFER_KEYS.AMOUNT)}</th>
                  <th>{t(BULK_TRANSFER_KEYS.REAPONSE)}</th>
                </tr>
              </thead>
              <tbody>
                {responseList.map((option, index) => (
                  <tr key={index}>
                    <td>{option.referenceNo}</td>
                    <td>{option.srcAcc}</td>
                    <td>{option.beneName}</td>
                    <td>{option.transferType}</td>
                    <td>{option.remarks}</td>
                    <td>{option.amount}</td>
                    <td>{option.message}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <div style={{ width: 150, margin: '30px auto' }}>
          <NeoButton
            type='button'
            text={t(BUTTON_KEYS.OK)}
            onClick={() => history.push('/transfers')}
            mode='newDesign'
          />
        </div>
      </>
    )
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  return (
    <LayoutWithOutAccountCard showEmptySpace={false} breadCumKey='BULK_TRANSFER'>
      <div className='heading-style'>{t(BULK_TRANSFER_KEYS.TITLE)}</div>
      {renderSwitch()}
    </LayoutWithOutAccountCard>
  )
}
